import React from 'react';

interface Props {
  children: any;
}

const Currency = ({ children, ...rest }: Props) => (
  <span dir="ltr" {...rest}>
    {children}
  </span>
  );

export default Currency;
